import { message } from 'antd';
import React from 'react';
import { Button, Card, CardBody, CardFooter, CardHeader, Input } from 'reactstrap';
import QuestionHeader from '../QuestionHeader';

const Conjugation = ({ data, onSubmit, userData, questionIndex = 0 }) => {
  const [state, setState] = React.useState({
    data: null,
    isSubmit: false,
    answersInput: [],
  });

  const onHandleInput = React.useCallback(
    (e, rowIndex, answerIndex, answer) => {
      const { answersInput } = state;
      const index = answersInput.findIndex((x) => x.rowIndex === rowIndex && x.answerIndex === answerIndex);
      if (index > -1) {
        answersInput[index].answer = e.target.value;
      } else {
        answersInput.push({ rowIndex, answerIndex, answer: e.target.value, correct: answer });
      }
      setState((prevState) => ({ ...prevState, answersInput }));
    },
    [state.answersInput],
  );

  const renderItem = React.useCallback(
    (answers) => {
      return answers.map((item, rowIndex) => {
        return (
          <tr key={rowIndex} style={{ marginInline: 10 }}>
            <td style={{ padding: 5, fontWeight: 600 }}>{item.answer}</td>
            {item.answersList.map((answer, answerIndex) => {
              const item = state.answersInput.find((x) => x.rowIndex === rowIndex && x.answerIndex === answerIndex);
              return (
                <td style={{ padding: 5 }} key={answerIndex}>
                  <Input autoComplete='off' value={item?.answer ?? ''} style={{ fontWeight: 600, color: 'green' }} onChange={(e) => onHandleInput(e, rowIndex, answerIndex, answer)} />
                </td>
              );
            })}
          </tr>
        );
      });
    },
    [onHandleInput, state.answersInput],
  );

  const renderQuestion = React.useCallback(
    (data) => {
      return (
        <React.Fragment>
          <CardHeader>
            <QuestionHeader title={data.title} subTitle={data.subTitle} questionIndex={questionIndex} tooltip='Conjugation' />
          </CardHeader>
          <CardBody className='d-flex flex-column'>
            <table style={{ width: 'fit-content' }}>
              <tbody>
                <tr>
                  <th style={{ padding: 5 }} />
                  <th style={{ padding: 5 }}>Quá khứ đơn</th>
                  <th style={{ padding: 5 }}>Quá khứ phân từ</th>
                </tr>
                {renderItem(data.answers)}
              </tbody>
            </table>
          </CardBody>
        </React.Fragment>
      );
    },
    [questionIndex, renderItem],
  );

  React.useEffect(() => {
    if (userData) {
      setState((prevState) => ({ ...prevState, data, answersInput: userData }));
      return;
    }
    setState((prevState) => ({ ...prevState, data }));
  }, [data, userData]);

  if (!state.data) return null;

  return (
    <Card>
      {renderQuestion(state.data)}
      <CardFooter>
        {
          <Button
            color='primary'
            disabled={state.answersInput.length < 1}
            onClick={() => {
              const { answersInput, data } = state;
              const { answers } = data;
              let result = true;
              let count = 0;
              answers.forEach((element) => {
                count += element.answersList.length;
              });

              if (userData) {
                onSubmit({ id: state.data.id, answers: state.answersInput });
              }
              setState((prevState) => ({ ...prevState, isSubmit: true }));

              if (answersInput.length === count) {
                answersInput.forEach((item) => {
                  if (item.correct.toLowerCase() !== item.answer.toLowerCase()) {
                    result = false;
                  }
                });
              } else result = false;

              // if (result) {
              //   message.success('Kết quả: ' + result);
              // } else {
              //   message.warning('Kết quả: ' + result);
              // }
              // Callback
              // if (onSubmit && typeof onSubmit === 'function') onSubmit(result);
              if (onSubmit && typeof onSubmit === 'function') onSubmit({ answers: answersInput, result });
            }}
          >
            Submit
            <i className='fas fa-arrow-right ml-3' />
          </Button>
        }
      </CardFooter>
    </Card>
  );
};

export default Conjugation;
